import {
  InfoModule,
  createInfoServices
} from "./chunk-EXZZNE6F.mjs";
import "./chunk-7PKI6E2E.mjs";
export {
  InfoModule,
  createInfoServices
};
